module.exports = __webpack_public_path__ + "static/media/14.294d5d8f.jpg";